// js
import { connect } from 'react-redux';
import DataSources from '../../components/analytics/DataSources';
import { getCompletedActiveConfiguredItems, getTotalDataPerDayForCompletedActiveConfiguredItems } from '../../selectors/dsa/sourcesSelectors';


const mapStateToProps = state => {
  return {
    completedActiveConfiguredItems: getCompletedActiveConfiguredItems(state),
    totalDataPerDay: getTotalDataPerDayForCompletedActiveConfiguredItems(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSources);



// WEBPACK FOOTER //
// ./src/containers/analytics/DataSources.js